import React, { useState } from "react";
import Select from "react-dropdown-select";
import { FiUploadCloud } from "react-icons/fi";
import "../SheetUpload/SheetBulkUploadPopup.scss";
import { useDispatch } from "react-redux";
import { EmployeeBulkUploadSucess } from "../../../Redux/Slice";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { getLoaderAction } from "../../../Redux/Loader";

const EmployeeBulkuploadPopup = ({ setPopup }) => {
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();

  const allowedTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const MAX_SIZE = 250 * 1024 * 1024; // 250MB

  //  Validate file
  const validateFile = (uploadedFile) => {
    if (!uploadedFile) return false;

    if (!allowedTypes.includes(uploadedFile.type)) {
      toast.error("Only Excel files (.xls, .xlsx) are allowed");
      return false;
    }

    if (uploadedFile.size > MAX_SIZE) {
      toast.error("File size should be less than 250MB");
      return false;
    }

    return true;
  };

  //  Drag & Drop
  const handleDrop = (e) => {
    e.preventDefault();

    const uploadedFile = e.dataTransfer.files[0];

    if (!validateFile(uploadedFile)) return;

    setFile(uploadedFile);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  //  File Input
  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];

    if (!validateFile(uploadedFile)) return;

    setFile(uploadedFile);
  };

  //  Upload
  const uploadFile = () => {
    if (!file) {
      toast.error("Please select a file");
      return;
    }

    const payload = {
      file: file,
      setPopup, // (you can remove later as discussed)
    };

    dispatch(EmployeeBulkUploadSucess(payload));
  };

  // Sample Download
  const downloadSample = () => {
    getLoaderAction(true);
    const headers = [
      "Prospect Name*",
      "Employee Name*",
      "Date Of Birth*",
      "Gender*",
      "Marital Status*",
      "Contact No*",
      "Current Address 1*",
      "Current Address 2*",
      "Current Address Pincode*",
      "Permanent Address 1*",
      "Permanent Address 2*",
      "Permanent Address Pincode*",
      "Personal email ID*",
      "Alternate Contact No",
      "Fathers Name",
      "E mail Domain Name*",
      "Aadhar Card*",
      "Pan Card Eligibility",
      "Pan Card*",
      "Working Experience*",
      "Name last organisation (If Experienced)",
      "Freelancer*",
      "Company Name*",
      "Country*",
      "State*",
      "Location*",
      "Employee Type*",
      "Designation*",
      "Project*",
      "Joining Date*",
      "Reporting Manager*",
      "Language",
      "Billable/Non Billable*",
      "Billing Type*",
      "Offer Entry Date*",
      "Is there any issue with KYC?*",
      "Service Offerings*",
      "AttendanceMode",
      "Holiday Applicable*",
      "Project Nature",
      "Hiring Source*",
      "Coordinator*",
      "Project Manager*",
      "Vertical Name",
      "Vertical Owner*",
      "Agency Names*",
      "Contract/Consultant/Probabtion Months*",
      "Attendance Cycle*",
      "Job Family",
      "Role Details",
      "Role*",
      "Grade*",
      "Grade Type*",
      "Notice Before Confirmation*",
      "Notice After Confirmation*",
      "Basic*",
      "HRA*",
      "Conveyance Allowance*",
      "Advance Statutory Bonus*",
      "Gross*",
      "Incentive Geting Time Period*",
      "PFCO*",
      "ESICo*",
      "PF Exp*",
      "Gratuity*",
      "LWF EMPLOYER*",
      "Insurance*",
      "Bonus",
      "Statutory Bonus*",
      "LB/Retention Bonus/JB",
      "Total Stat Compl*",
      "IncentiveVariablePLA",
      "Stipend*",
      "CTC*",
      "EPF EMP*",
      "ESI EMP*",
      "PTAX*",
      "LWF Employee*",
      "TotalDeduction*",
      "InHand*",
      "Medical Insurance*",
      "Accidential Insurance*",
      "Mobile Expence Reimbursement*",
      "Conveyance Reimbursement*",
      "Internet Reimbursement*",
      "Tour Reimbursement*",
      "CTC Reimbursement*",
      "Annual Performance based Loyalty Incentive*",
      "Annual CTC*",
      "Annual CTC with Reimbursement*",
      "Payout Category*",
      "Is Coordinator*",
      "Consultancy Fee",
      "Workingstatus",
      "Bonus Applicable*",
      "Performance Linked Allowance*",
      "Employee Catergory*",
    ];

    // ✅ wrap in array → one row
    const ws = XLSX.utils.aoa_to_sheet([headers]);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample");

    XLSX.writeFile(wb, "Employee_Bulkupload_Sample.xlsx");
    getLoaderAction(false);
  };

  return (
    <div className="overlay">
      <div className="popupContainers">
        {/* Header */}
        <div className="popupHeader">
          <div />
          <span className="TitleHeader">Verification Bulkupload</span>
          <button className="closeButton" onClick={() => setPopup(false)}>
            ×
          </button>
        </div>

        {/* Dropdown */}
        <div
          className="uploadTypeHeader"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          {/* <Select
            className="Selects"
            options={options}
            values={fileType}
            onChange={(value) => setFileType(value)}
            style={{ width: "480px", marginBottom: "0px" }}
            dropdownStyle={{ width: "480px" }}
          /> */}

          <button
            className="sampleSheetBtn"
            onClick={downloadSample}
            style={{ textWrap: "nowrap", width: "35%" }}
          >
            Sample Sheet
          </button>
        </div>

        {/* Drag & Drop */}
        <div
          className="uploadBox"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <FiUploadCloud className="uploadIcon" />

          <p className="mainText">
            Click to select or drag & drop your Excel file
          </p>

          <p className="subText">Supported formats: .xls, .xlsx</p>
          <p className="subText">Max file size 250MB</p>

          <input type="file" onChange={handleFileChange} accept=".xls,.xlsx" />

          {file && <p className="fileName">{file.name}</p>}
        </div>

        {/* Submit */}
        <button className="submitBtn" disabled={!file} onClick={uploadFile}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default EmployeeBulkuploadPopup;
